import { render, staticRenderFns } from "./WorkspaceMenu.vue?vue&type=template&id=0bf81be1&scoped=true"
import script from "./WorkspaceMenu.vue?vue&type=script&lang=js"
export * from "./WorkspaceMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf81be1",
  null
  
)

export default component.exports